import React, { useEffect, useState } from 'react';
// @ts-ignore
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
// @ts-ignore
import draftToHtml from 'draftjs-to-html';
// @ts-ignore
import htmlToDraft from 'html-to-draftjs';
import { isString } from 'lodash';

interface Props {
	value?: string | { plain: string; html: string };
	onChange: ({ plain, html }: { plain: string; html: string }) => void;
	isRequired?: boolean;
	onEditorStateLoad?: (editorState: EditorState) => void;
	charactersLimit?: number;
}

const RichText: React.FC<Props> = ({
	value,
	onChange,
	isRequired = false,
	onEditorStateLoad,
	charactersLimit,
}) => {
	const [editorState, setEditorState] = useState<EditorState | undefined>(
		undefined,
	);

	useEffect(() => {
		if (!value) return;

		const initValue = isString(value)
			? value
			: 'html' in value
			? value.html
			: undefined;

		if (!initValue) return;

		setEditorState(() =>
			EditorState.createWithContent(
				ContentState.createFromBlockArray(htmlToDraft(initValue)),
			),
		);
	}, []);

	useEffect(() => {
		if (editorState) {
			const content = editorState.getCurrentContent();
			const html = draftToHtml(convertToRaw(content));
			const plain = content.getPlainText('\n');
			onChange({ plain, html });
			onEditorStateLoad?.(editorState);
		}
	}, [editorState, onChange, onEditorStateLoad]);

	return (
		<Editor
			editorState={editorState}
			onEditorStateChange={setEditorState}
			editorClassName='richTextField'
			isRequired={isRequired}
			stripPastedStyles
			handlePastedText={() => false}
			handleBeforeInput={(
				chars: string,
				state: EditorState,
			): 'handled' | 'not-handled' => {
				const length = state.getCurrentContent().getPlainText('').length;
				if (charactersLimit && length >= charactersLimit) {
					return 'handled';
				}
				return 'not-handled';
			}}
			toolbar={{
				options: ['inline', 'list', 'textAlign', 'history'],
				inline: {
					inDropdown: false,
					options: ['bold', 'italic', 'underline', 'strikethrough'],
				},
			}}
		/>
	);
};

export default RichText;
